module.exports = __webpack_public_path__ + "static/media/hero-home-2.b2c85d0c.png";